'use client';

import { motion } from 'framer-motion';

import GradientNoiseGlow from '~/components/survey-builder/shared/gradient-noise-glow';

import { AboutIcons } from '../icons';
import HeroBackground from '../sections/new-hero/background';
import GlowingBadge from '../ui/glowing-badge';

const AwardsRecognitionsSection = () => {
  const awards = [
    {
      icon: AboutIcons.expandedGlobally,
      title: 'AI Summit Europe 2024 – Top Startup to Watch',
      description:
        'Selected as one of the most promising early-stage AI companies redefining decision-making at scale.',
    },
    {
      icon: AboutIcons.university,
      title: 'TUM Innovation Hub (Munich) – Official Program Member',
      description:
        'Proud to be part of the Technical University of Munich’s innovation ecosystem, fostering next-gen software built in Europe.',
    },
  ];

  return (
    <section className="module-awards-recognitions relative mx-auto flex w-full flex-col items-center justify-start overflow-hidden pb-[120px] pt-[124px]">
      <div className="relative z-30 mx-auto w-full max-w-1440 px-6 lg:px-24">
        <motion.div
          className="mb-4 flex lg:mb-3"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <GlowingBadge>
            <AboutIcons.awardsRecognitions />
            <span>Awards & Recognitions</span>
          </GlowingBadge>
        </motion.div>
        <motion.div
          className="flex flex-col justify-between gap-10 lg:flex-row"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <div className="max-w-[721px]">
            <h2 className="text-5xl font-semibold leading-[1.3] lg:text-5xl lg:leading-[1.4]">
              Recognized for Redefining What’s Possible
            </h2>
          </div>
          <div className="mt-12 max-w-[402px] text-lg leading-[1.5] tracking-[-1px] text-white/60">
            <p>
              From leading innovation hubs to national award programs, Saights
              has been recognized for its product quality, technical strength,
              and real-world relevance. These acknowledgements reflect growing
              awareness from the people and institutions that matter.
            </p>
          </div>
        </motion.div>
        <motion.div
          className="mt-10 grid grid-cols-1 gap-x-10 gap-y-10 lg:mt-19 lg:grid-cols-3 lg:gap-x-14 lg:gap-y-20"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          {awards.map((award, index) => (
            <div
              key={`${award.title}-${index}`}
              className="flex flex-col items-center lg:items-start"
            >
              <div className="item-box flex w-fit shrink-0 items-center justify-center overflow-hidden rounded-full bg-neutral-900">
                <div className="icon-container flex h-[51px] w-[51px] items-center justify-center">
                  <GradientNoiseGlow
                    className="relative flex h-full flex-1 items-center justify-center"
                    size="large"
                    visible={false}
                  >
                    <award.icon className="h-10 w-10" />
                  </GradientNoiseGlow>
                </div>
              </div>
              <h3 className="mt-6 text-lg font-medium leading-[1.5] tracking-[-0.8px] text-white">
                {award.title}
              </h3>
              <p className="mt-1 text-sm leading-[1.5] text-white/50">
                {award.description}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
      <HeroBackground
        showSquares={false}
        showLights={false}
        glowProps={{
          animate: { opacity: 0.3, scale: 1 },
          className: 'top-[-100px]',
        }}
        particlesProps={{
          quantity: 100,
        }}
      />
    </section>
  );
};

export default AwardsRecognitionsSection;
